<template>
  <div>
    <Header /> 

    <PageContainer>
      <div class="iqos-grid">
        <div class="iqos-column">
          <PasswordPanel />
          <TwoFactorAuthPanel />
        </div>
        <div class="iqos-column">
          <EmailPanel  />
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<style scoped>

</style>

<script>
import EmailPanel from "@/components/settings/EmailPanel.vue";
import LanguagePanel from "@/components/settings/LanguagePanel.vue";
import PasswordPanel from "@/components/settings/PasswordPanel.vue";
import TwoFactorAuthPanel from "@/components/settings/TwoFactorAuthPanel.vue";

export default {
  data() {
    return {};
  },
  components: {
    EmailPanel,
    LanguagePanel,
    PasswordPanel,
    TwoFactorAuthPanel
  }
};
</script>